export default __webpack_public_path__ + "static/media/infra-14.2065a45d.webp";